type EnsureAllItems<Item, Arr extends Array<unknown>> =
  [Item] extends [Arr[number]] ? Arr : "Some items are missing from the array";

/**
 * A noop builder to enforce that the passed array contains all the items defined
 * in the given type parameter.
 *
 * We could use some TS trickery converting a union to a tuple, but it is
 * discouraged and complex to understand (cf. https://stackoverflow.com/a/55128956)
 */
export const exhaustiveArray = <TItem>() => ({
  ensure: <const TArray extends Array<TItem>>(
    array: EnsureAllItems<TItem, TArray>,
  ) => array,
});
